<template>
  <div class="seek_list_page">
    <div class="filter-container">
      <el-form :inline="true" :model="formInline" class="search-container" :label-width="labelWidth">
        <el-form-item :label="$t('seek.consultationNumber') + ':'">
          <el-input
            v-model="formInline.consultNum"
            :placeholder="$t('home.placeholder')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('seek.theme') + ':'">
          <el-input
            v-model="formInline.consultSubject"
            :placeholder="$t('home.placeholder')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('seek.status') + ':'">
          <el-select v-model="formInline.status" filterable clearable>
            <el-option :label="$t('home.all')" value=""></el-option>
            <el-option :label="$t('home.waitSl')" value="0"></el-option>
            <el-option :label="$t('home.slIng')" value="1"></el-option>
            <el-option :label="$t('home.closed')" value="2"></el-option>
            <el-option :label="$t('home.canceled')" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('home.brand') + ':'">
          <el-input
            v-model="formInline.carBrand"
            :placeholder="$t('home.placeholder')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('home.carType') + ':'">
          <el-input
            v-model="formInline.carModel"
            :placeholder="$t('home.placeholder')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('seek.culpritName') + ':'">
          <el-input
            v-model="formInline.suspectedCulpritName"
            :placeholder="$t('home.placeholder')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('seek.culpritCode') + ':'">
          <el-input
            v-model="formInline.suspectedCulpritCode"
            :placeholder="$t('home.placeholder')"
          ></el-input>
        </el-form-item>
        <el-form-item label="VIN:">
          <el-input
            v-model="vin"
            :placeholder="$t('home.placeholder')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('seek.consultationDate') + ':'">
          <el-date-picker
            v-model="formInline.date"
            type="daterange"
            range-separator="-"
            value-format="yyyy-MM-dd"
            :start-placeholder="$t('cart.startDate')"
            :end-placeholder="$t('cart.endDate')"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="searchButton">
        <div>
          <el-button
          type="primary"
          class="primary-btn"
          icon="el-icon-plus"
          @click="handleAdd"
          >{{ $t("home.add") }}</el-button
        >
        <el-button
          type="primary"
          class="primary-btn"
          plain
          icon="el-icon-download"
          @click="handleExport"
          >{{ $t("cart.export") }}</el-button
        >
        </div>
        <div>
          <el-button
            class="primary-btn"
            type="primary"
            @click="onSubmit"
          >
            <i class="subSearch-icon"></i>
            {{$t("home.query")}}
          </el-button>
          <el-button
            class="primary-btn"
            plain
            @click="handleResetQuery"
          >
            <i class="el-icon-refresh-right"></i>
            {{ $t("home.reset") }}
          </el-button>
        </div>
      </div>
    </div>
    <div class="list">
      <el-table
        stripe
        border
        ref="singleTable"
        :data="tableData"
        highlight-current-row
        @current-change="handleCurrentChange"
        :max-height="maxHeight"
        :row-class-name="tableRowClassName"
      >
        <!-- 序号 -->
        <el-table-column
          type="index"
          :label="$t('cart.xh')"
          width="60"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 咨询工单号 -->
        <el-table-column
          property="consultNum"
          :label="$t('seek.consultationNumber')"
          width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 咨询主题 -->
        <el-table-column
          property="consultSubject"
          :label="$t('seek.theme')"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 未读消息 -->
        <el-table-column
          property="notificationCount"
          :label="$t('seek.unread')"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 品牌 -->
        <el-table-column
          property="carBrand"
          :label="$t('home.brand')"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 车型 -->
        <el-table-column
          property="carModel"
          :label="$t('home.carType')"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- vin -->
        <el-table-column
          property="vin"
          label="VIN"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 疑似/祸首件名称 -->
        <el-table-column
          property="suspectedCulpritName"
          :label="$t('seek.culpritName')"
          :render-header="$globalRenderHeader"
          min-width="120"
          align="center"
        >
        </el-table-column>
        <!-- 疑似/祸首件代码 -->
        <el-table-column
          property="suspectedCulpritCode"
          :label="$t('seek.culpritCode')"
          :render-header="$globalRenderHeader"
          min-width="120"
          align="center"
        >
        </el-table-column>
        <!-- 咨询日期 -->
        <el-table-column
          property="createTime"
          :label="$t('seek.consultationDate')"
          min-width="160"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 咨询工单状态 -->
        <el-table-column
          property="status"
          :label="$t('seek.status')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ getStatus(scope.row.status) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          property="staffName"
          :label="$t('seek.replyPeople')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="lastReplyTime"
          :label="$t('seek.latestTime')"
          min-width="160"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <el-table-column
          :label="$t('cart.operate')"
          align="center"
          width="160px"
          fixed="right"
          :render-header="$globalRenderHeader"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="handleDetail(scope.row)"
              >{{ $t("operate.view") }}</el-button
            >
            <el-button
              v-if="scope.row.status == 0"
              type="text"
              @click="handleCancel(scope.row)"
              >{{ $t("seek.cancelSeek") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye">
        <pagination
          v-if="total > 0"
          :total="total"
          :page.sync="page"
          :limit.sync="pageSize"
          @pagination="changePage"
        />
        <!-- <el-pagination
          @size-change="handleSizeChange"
          @current-change="changePage"
          :current-page="page"
          :page-sizes="[10, 15, 20, 30]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination> -->
      </div>
    </div>
  </div>
</template>
<script>
import {
  seekList,
  getBrand,
  getModel,
  exportSeek,
  cancelSeek
} from '@/api/seek'
import { setStorage, getStorage } from '@/util/localStor'
import { getDownloadFiles } from '@/util/downFile'
export default {
  data () {
    return {
      maxHeight:　null,
      vinVal: '',
      formInline: {
        consultNum: '',
        consultSubject: '',

        suspectedCulpritName: '',
        suspectedCulpritCode: '',
        carBrand: '',
        carModel: '',
        status: '',
        vin: ''
      },
      nowSearch: {
        consultNum: '',
        consultSubject: '',
        suspectedCulpritName: '',
        suspectedCulpritCode: '',
        carBrand: '',
        carModel: '',
        status: '',
        vin: ''
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      brandList: [],
      modelList: []
    }
  },
  computed: {
    vin: {
      get: function () {
        return this.vinVal
      },
      set: function (val) {
        this.vinVal = val.toUpperCase()
        this.formInline.vin = this.vinVal
      }
    },
    labelWidth() {
      const widthMap = {
        zh: "120px",
        en: "240px",
        ru: "300px",
        fa: "165px",
        vi: "260px",
        es: "290px",
      };
      return widthMap[this.$i18n.locale] || "150px";
    },
  },
  mounted () {
    this.getList()
    // let unread = getStorage('zxMsg')
    // if(){}
    // this.getBrandList()
  },
  methods: {
    // handleSizeChange (val) {
    //   this.pageSize = val
    //   this.getList()
    // },
    tableRowClassName ({ row, rowIndex }) {
      if (row.notificationCount > 0) {
        return 'warning-row'
      }
      return ''
    },
    // handlePre (val) {
    //   this.page = val
    //   this.getList()
    // },
    // handleNext (val) {
    //   this.page = val
    //   this.getList()
    // },
    changePage (val) {
      this.page = val.page;
      this.pageSize = val.limit
      this.getList()
    },
    changeBrand (val) {
      if (val == '') {
        this.formInline.carModel = ''
        this.modelList = []
      } else {
        this.formInline.carModel = ''
        this.getModelList(val)
      }
    },
    async getBrandList () {
      const res = await getBrand()
      if (res.status == 0) {
        this.brandList = [
          { carBrandName: this.$t('home.all'), carBrandId: '' },
          ...res.data.carBrandSpinner
        ]
      }
    },
    async getModelList (id) {
      const query = {
        data: {
          carBrandId: id
        }
      }
      const res = await getModel(query)

      if (res.status == 0) {
        this.modelList = [
          { carModelName: this.$t('home.all'), carModelId: '' },
          ...res.data.carModelSpinner
        ]
      }
    },
    getStatus (data) {
      let status
      if (data == 0) status = this.$t('home.waitSl')
      if (data == 1) status = this.$t('home.slIng')
      if (data == 2) status = this.$t('home.closed')
      if (data == 3) status = this.$t('home.canceled')
      return status
    },
    handleAdd () {
      this.$router.push('/newSeek')
    },
    handleDetail (row) {
      this.$router.push({
        name: 'seekDetail',
        query: { unread: row.notificationCount, seeId: row.consultNum }
      })
      setStorage('seekData', row)
    },
    async getList () {
      const query = {
        data: {
          ...this.nowSearch
        },
        page: {
          pageNum: this.page,
          pageSize: this.pageSize
        }
      }
      const res = await seekList(query)
      if (res.status == 0) {
        this.tableData = res.data.records
        this.total = res.data.count
      } else {
        this.$DonMessage.warning(res.message)
      }
      this.getTableHighest(this, "maxHeight");
    },
    onSubmit () {
      this.page = 1
      this.pageSize = 10
      this.nowSearch.consultNum = this.formInline.consultNum
      this.nowSearch.consultSubject = this.formInline.consultSubject
      this.nowSearch.suspectedCulpritName =
        this.formInline.suspectedCulpritName
      this.nowSearch.suspectedCulpritCode =
        this.formInline.suspectedCulpritCode
      this.nowSearch.carBrand = this.formInline.carBrand
      this.nowSearch.carModel = this.formInline.carModel
      this.nowSearch.status = this.formInline.status
      this.nowSearch.vin = this.formInline.vin
      if (this.formInline.date) {
        this.nowSearch.createTimeStart = this.formInline.date[0] + ' 00:00:00'
        this.nowSearch.createTimeEnd = this.formInline.date[1] + ' 23:59:59'
        // if(this.nowSearch.createTimeStart==this.nowSearch.createTimeEnd){
        //   this.nowSearch.createTimeStart= this.formInline.date[0]+' 00:00:00'
        //   this.nowSearch.createTimeEnd = this.formInline.date[0]+' 23:59:59'
        // }
      } else {
        this.nowSearch.createTimeStart = ''
        this.nowSearch.createTimeEnd = ''
      }
      this.getList()
    },
    handleCurrentChange () {},
    async handleExport () {
      const query = {
        data: {
          ...this.nowSearch
        }
      }
      const res = await exportSeek(query)
      getDownloadFiles(res)
      if (res.fileName) {
        this.$DonMessage.success(this.$t('request.exportOrder'));
      }
    },
    // 重置查询条件
    handleResetQuery () {
      this.formInline = Object.assign({}, this.$options.data()?.formInline)
      this.onSubmit()
    },
    // 取消咨询
    async handleCancel (row) {
      await this.$confirm(
        `${this.$t('seek.isCancelSeek') + ':' + row.consultNum}？`,
        this.$t('request.tips'),
        {
          cancelButtonClass: 'confirm-btn-close',
          confirmButtonClass: 'confirm-btn-confirm'
        }
      )
      const res = await cancelSeek({
        data: {
          qualityInquiryFormId: row.qualityInquiryFormId,
          status: 3
        }
      })
      if (res.status == 0) {
        this.$DonMessage.success(this.$t('message.czcg'))
        this.getList()
      } else {
        this.$DonMessage.warning(res.message)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.search-container {
  // padding: 0 60px;
}
.list {
  // padding: 0 7px 0 23px;
}
.list ::v-deep .el-table .warning-row {
  // background: oldlace;
}
.tools {
  // margin-top: 30px;
  // border-bottom: 5px solid #efefef;
  ::v-deep .el-input {
    // width: 200px;
  }
}
</style>
<style lang="scss">
// .el-message-box__btns {
//   .confirm-btn-close:hover {
//     color: #bd3124;
//     border-color: #bd3124;
//     background-color: #ffdfdc;
//   }
//   .confirm-btn-confirm {
//     background-color: #bd3124;
//     border-color: #bd3124;
//   }
// }
</style>
